module.exports = __webpack_public_path__ + "static/media/img22.a17c4f6c.JPG";